<div id="mauticform_wrapper_passo2informacoesbasicas2" class="mauticform_wrapper">
    <form autocomplete="false" role="form" method="post" action="{{formApiUrl}}?formId=17"
        id="mauticform_passo2informacoesbasicas2" data-mautic-form="passo2informacoesbasicas2"
        enctype="multipart/form-data" #form>
        <div class="mauticform-error" id="mauticform_passo2informacoesbasicas2_error"></div>
        <div class="mauticform-message" id="mauticform_passo2informacoesbasicas2_message"></div>
        <div class="mauticform-innerform">


            <div class="mauticform-page-wrapper mauticform-page-1" data-mautic-form-page="1">

                <div id="mauticform_passo2informacoesbasicas2_email" data-validate="email" data-validation-type="email"
                    class="mauticform-row mauticform-email mauticform-field-1 mauticform-required">
                    <input id="mauticform_input_passo2informacoesbasicas2_email" name="mauticform[email]"
                        [value]="formData.email" class="mauticform-input" type="email">
                </div>

                <div id="mauticform_passo2informacoesbasicas2_sexo" data-validate="sexo" data-validation-type="text"
                    class="mauticform-row mauticform-text mauticform-field-1 mauticform-required">
                    <input id="mauticform_input_passo2informacoesbasicas2_sexo" name="mauticform[sexo]"
                        [value]="formData.gender" class="mauticform-input" type="text">
                </div>

                <div id="mauticform_passo2informacoesbasicas2_data_de_nascimento" data-validate="data_de_nascimento"
                    data-validation-type="text"
                    class="mauticform-row mauticform-text mauticform-field-2 mauticform-required">
                    <input id="mauticform_input_passo2informacoesbasicas2_data_de_nascimento"
                        name="mauticform[data_de_nascimento]" [value]="formData.birthdate" class="mauticform-input"
                        type="text">
                </div>

                <div id="mauticform_passo2informacoesbasicas2_cep" data-validate="cep" data-validation-type="text"
                    class="mauticform-row mauticform-text mauticform-field-3 mauticform-required">
                    <input id="mauticform_input_passo2informacoesbasicas2_cep" name="mauticform[cep]"
                        [value]="formData.zipCode" class="mauticform-input" type="text">
                </div>

                <div id="mauticform_passo2informacoesbasicas2_estado"
                    class="mauticform-row mauticform-text mauticform-field-4 mauticform-required">
                    <input id="mauticform_input_passo2informacoesbasicas2_estado" name="mauticform[estado]"
                        [value]="formData.stateName" class="mauticform-input" type="text">
                </div>

                <div id="mauticform_passo2informacoesbasicas2_bairro" data-validate="bairro" data-validation-type="text"
                    class="mauticform-row mauticform-text mauticform-field-5 mauticform-required">
                    <input id="mauticform_input_passo2informacoesbasicas2_bairro" name="mauticform[bairro]"
                        [value]="formData.district" class="mauticform-input" type="text">
                </div>

                <div id="mauticform_passo2informacoesbasicas2_logradouro" data-validate="logradouro"
                    data-validation-type="text"
                    class="mauticform-row mauticform-text mauticform-field-6 mauticform-required">
                    <input id="mauticform_input_passo2informacoesbasicas2_logradouro" name="mauticform[logradouro]"
                        [value]="formData.street" class="mauticform-input" type="text">
                </div>

                <div id="mauticform_passo2informacoesbasicas2_numero" data-validate="numero"
                    data-validation-type="number"
                    class="mauticform-row mauticform-number mauticform-field-7 mauticform-required">
                    <input id="mauticform_input_passo2informacoesbasicas2_numero" name="mauticform[numero]"
                        [value]="formData.number" class="mauticform-input" type="number">
                </div>

                <div id="mauticform_passo2informacoesbasicas2_complemento"
                    class="mauticform-row mauticform-text mauticform-field-8">
                    <input id="mauticform_input_passo2informacoesbasicas2_complemento" name="mauticform[complemento]"
                        [value]="formData.complement || null" class="mauticform-input" type="text">
                </div>

                <div id="mauticform_passo2informacoesbasicas2_cidade" data-validate="cidade" data-validation-type="text"
                    class="mauticform-row mauticform-text mauticform-field-10 mauticform-required">
                    <input id="mauticform_input_passo2informacoesbasicas2_cidade" name="mauticform[cidade]"
                        [value]="formData.city + ', '  + formData.state" class="mauticform-input" type="text">
                </div>

                <div id="mauticform_passo2informacoesbasicas2_concluido"
                    class="mauticform-row mauticform-text mauticform-field-11">
                    <input id="mauticform_input_passo2informacoesbasicas2_concluido" name="mauticform[concluido]"
                        value="true" class="mauticform-input" type="text">
                </div>

                <div id="mauticform_passo2informacoesbasicas2_submit"
                    class="mauticform-row mauticform-button-wrapper mauticform-field-9">
                    <button type="submit" name="mauticform[submit]"
                        id="mauticform_input_passo2informacoesbasicas2_submit" value=""
                        class="mauticform-button btn btn-default">Submit</button>
                </div>
            </div>
        </div>

        <input type="hidden" name="mauticform[formId]" id="mauticform_passo2informacoesbasicas2_id" value="17">
        <input type="hidden" name="mauticform[return]" id="mauticform_passo2informacoesbasicas2_return" value="">
        <input type="hidden" name="mauticform[formName]" id="mauticform_passo2informacoesbasicas2_name"
            value="passo2informacoesbasicas2">

    </form>
</div>